// stateLinks.js

const stateLinks = [
  { name: "Alabama", url: "https://alabamatrails.netlify.app/" },
  { name: "Alaska", url: "https://alaskatrails.netlify.app/" },
  { name: "Arizona", url: "https://arizonatrails.netlify.app/" },
  { name: "Arkansas", url: "https://arkansastrails.netlify.app/" },
  { name: "California", url: "https://californiatrails.netlify.app/" },
  { name: "Colorado", url: "https://coloradotrails.netlify.app/" },
  { name: "Connecticut", url: "https://connecticuttrails.netlify.app/" },
  { name: "Delaware", url: "https://delawaretrails.netlify.app/" },
  { name: "Florida", url: "https://floridatrails.netlify.app/" },
  { name: "Georgia", url: "https://georgiatrails.netlify.app/" },
  { name: "Hawaii", url: "https://hawaiitrails.netlify.app/" },
  { name: "Idaho", url: "https://idahotrails.netlify.app/" },
  { name: "Illinois", url: "https://illinoistrails.netlify.app/" },
  { name: "Indiana", url: "https://indianatrails.netlify.app/" },
  { name: "Iowa", url: "https://iowatrails.netlify.app/" },
  { name: "Kansas", url: "https://kansastrails.netlify.app/" },
  { name: "Kentucky", url: "https://kentuckytrails.netlify.app/" },
  { name: "Louisiana", url: "https://louisianatrails.netlify.app/" },
  { name: "Maine", url: "https://mainetrails.netlify.app/" },
  { name: "Maryland", url: "https://marylandtrails.netlify.app/" },
  { name: "Massachusetts", url: "https://massachusettstrails.netlify.app/" },
  { name: "Michigan", url: "https://michigantrails.netlify.app/" },
  { name: "Minnesota", url: "https://minnesotatrails.netlify.app/" },
  { name: "Mississippi", url: "https://mississippitrails.netlify.app/" },
  { name: "Missouri", url: "https://missouritrails.netlify.app/" },
  { name: "Montana", url: "https://montanatrails.netlify.app/" },
  { name: "Nebraska", url: "https://nebraskatrails.netlify.app/" },
  { name: "Nevada", url: "https://nevadatrails.netlify.app/" },
  { name: "New Hampshire", url: "https://newhampshiretrails.netlify.app/" },
  { name: "New Jersey", url: "https://newjerseytrails.netlify.app/" },
  { name: "New Mexico", url: "https://newmexicotrails.netlify.app/" },
  { name: "New York", url: "https://newyorktrails.netlify.app/" },
  { name: "North Carolina", url: "https://northcarolinatrails.netlify.app/" },
  { name: "North Dakota", url: "https://northdakotatrails.netlify.app/" },
  { name: "Ohio", url: "https://ohiotrails.netlify.app/" },
  { name: "Oklahoma", url: "https://oklahomatrails.netlify.app/" },
  { name: "Oregon", url: "https://oregontrails.netlify.app/" },
  { name: "Pennsylvania", url: "https://pennsylvaniatrails.netlify.app/" },
  { name: "Rhode Island", url: "https://rhodeislandtrails.netlify.app/" },
  { name: "South Carolina", url: "https://southcarolinatrails.netlify.app/" },
  { name: "South Dakota", url: "https://southdakotatrails.netlify.app/" },
  { name: "Tennessee", url: "https://tennesseetrails.netlify.app/" },
  { name: "Texas", url: "https://texastrails.netlify.app/" },
  { name: "Utah", url: "https://utahtrails.netlify.app/" },
  { name: "Vermont", url: "https://vermonttrails.netlify.app/" },
  { name: "Virginia", url: "https://virginiatrails.netlify.app/" },
  { name: "Washington", url: "https://washingtontrails.netlify.app/" },
  { name: "West Virginia", url: "https://westvirginiatrails.netlify.app/" },
  { name: "Wisconsin", url: "https://wisconsintrails.netlify.app/" },
  { name: "Wyoming", url: "https://wyomingtrails.netlify.app/" },
  {
    name: "District of Columbia",
    url: "https://districtofcolumbiatrails.netlify.app/",
  },
];

export default stateLinks;
